// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.creditCard__dot {
  height: 8px;
  width: 8px;
  background-color: #14b084;
}
.creditCard__dot1 {
  height: 8px;
  width: 8px;
  background-color: #008556;
}

.creditcard__progressBar {
  background-color: #008556 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/CreditCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".creditCard__dot {\r\n  height: 8px;\r\n  width: 8px;\r\n  background-color: #14b084;\r\n}\r\n.creditCard__dot1 {\r\n  height: 8px;\r\n  width: 8px;\r\n  background-color: #008556;\r\n}\r\n\r\n.creditcard__progressBar {\r\n  background-color: #008556 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
